import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { ITenForceWindow } from "../../../global"

declare let window: ITenForceWindow

interface Props {
    label: string
}

export const CreateNewItemButton = ({ label }: Props): JSX.Element => (
    <Action
        id="createNewItemButton"
        title={label}
        onClick={(): void => window.cni.getInstance().toggle()}
        actionType={ActionType.icon}
        extraClasses="is-inverted"
    >
        {Symbols.Create}
    </Action>
)

export default CreateNewItemButton
